import React from 'react';
import { usePlacePhotoUrls } from '../../../hooks/usePlacePhotoUrls';
import useToast from '../../../hooks/useToast';
import { useAppDispatch } from '../../../redux/hooks';
import { TripCard } from '../../../redux/trip/trip.types';
import { handleCoverImageChange } from '../../../utils/CardDetails';
import CardImageGallery from '../../CardDetailsModal/CardImageGallery/CardImageGallery';

interface CoverPhotoModalProps {
  card: TripCard;
  tripId: string;
  isOpen: boolean;
  onClose: () => void;
}

function CoverPhotoModal({ card, tripId, isOpen, onClose }: CoverPhotoModalProps) {
  const dispatch = useAppDispatch();
  const { showSnackbarMessage } = useToast();
  const { urls: imgUrls } = usePlacePhotoUrls(card.photoReferences, card.imgUrls, isOpen);

  const handleSubmitCoverImageChange = (newCoverImage: number) => {
    handleCoverImageChange(newCoverImage, tripId, card.id, dispatch, onClose, showSnackbarMessage);
  };

  // Only render if card has images
  if (imgUrls.length === 0) {
    return null;
  }

  return (
    <CardImageGallery
      imgUrls={imgUrls}
      isEdit={true}
      galleryOpen={isOpen}
      handleGalleryClose={onClose}
      originalSelectedImgIndex={card.defaultImage}
      submitCoverImageChange={handleSubmitCoverImageChange}
    />
  );
}

CoverPhotoModal.displayName = 'CoverPhotoModal';
export default CoverPhotoModal;
